import LocalizedStrings from 'localized-strings';

import { AccountingExportOption } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    contentTitle: 'The following elements will be included:',
    items: {
      [AccountingExportOption.Transactions]: 'Transactions (CSV, QIF and OFX)',
      [AccountingExportOption.Invoices]: 'Sales and services',
      [AccountingExportOption.Receipts]: 'Purchases',
      [AccountingExportOption.BankStatements]: 'Bank statements',
    },
    oneOff: {
      description:
        'In a few minutes, your export {period} will be sent to **{name}** by email to **{email}**.',
      title: 'Your export is in progress!',
    },
    recurring: {
      description:
        'The export will be sent every **5th day of the month** starting from **{nextFifth}** to **{name}**, by email to **{email}**.',
      title: 'Your export has been scheduled!',
    },
  },
  fr: {
    contentTitle: 'Il contiendra les éléments suivants\xa0:',
    items: {
      [AccountingExportOption.Transactions]: 'Transactions (CSV, QIF et OFX)',
      [AccountingExportOption.Invoices]: 'Ventes et prestations',
      [AccountingExportOption.Receipts]: 'Achats',
      [AccountingExportOption.BankStatements]: 'Relevés bancaires',
    },
    oneOff: {
      description:
        'Il sera envoyé à **{name}** par e-mail à **{email}** pour la période {period} d’ici quelques minutes.',
      title: 'Votre export est en route\xa0!',
    },
    recurring: {
      description:
        'Il sera envoyé à **{name}** par e-mail à l’adresse **{email}** tous les **5ème jours du mois** à partir du **{nextFifth}**.',
      title: 'Votre export est planifié\xa0!',
    },
  },
} as const);

export default locales;
